import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SoftwareChrome = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4ZM26 16C26 18.927 24.736 21.565 22.724 23.395C21.955 23.862 20.937 23.765 20.273 23.101C19.493 22.321 19.493 21.052 20.273 20.272C20.354 20.191 20.417 20.099 20.465 20.002C21.419 18.939 22 17.536 22 15.999C22 13.742 20.747 11.773 18.901 10.749C19.581 10.032 20 9.064 20 7.999C20 7.563 19.929 7.144 19.799 6.751C23.434 8.25 25.999 11.83 25.999 15.999L26 16ZM16 12C18.206 12 20 13.794 20 16C20 18.206 18.206 20 16 20C13.794 20 12 18.206 12 16C12 13.794 13.794 12 16 12ZM16 6C17.103 6 18 6.897 18 8C18 9.103 17.103 10 16 10C13.743 10 11.774 11.253 10.75 13.099C10.033 12.418 9.065 12 8 12C7.564 12 7.145 12.071 6.752 12.2C8.251 8.565 11.831 6 16 6V6ZM6 16C6 14.897 6.897 14 8 14C9.103 14 10 14.897 10 16C10 19.308 12.691 22 16 22C16.587 22 17.154 21.914 17.691 21.756C17.708 22.758 18.097 23.754 18.859 24.516C19.154 24.811 19.484 25.05 19.836 25.234C18.654 25.727 17.358 26.001 15.999 26.001C10.485 26.001 5.999 21.515 5.999 16.001L6 16Z" />
	</svg>
);

export default SoftwareChrome;
